/* CFaithS ambience (17 Oct 2026): a few faint crosses drift slowly upward and fade in and out, with one soft light
   moving behind them. Canvas at 30 fps; pauses when the host is off screen or the tab is hidden; reduced-motion
   visitors get one still frame. 19 Oct 2026 (Hunter): the host is the header (the top section with the logo), no
   longer the hero. The 15% reduction asked for earlier that day was taken back the same afternoon ("it looked
   better before"), so SUBTLE is 1 and the intensity and count are the 17 Oct values. The host is the first element
   with data-cf-ambient, or the hero as before. */
(function () {
  'use strict';
  var hero = document.querySelector('[data-cf-ambient]') || document.querySelector('.cf-hero');
  if (!hero || !window.requestAnimationFrame) return;
  var wrap = hero.querySelector('.cf-ambient, .cf-hero__ambient');
  if (!wrap) return;
  var cv = document.createElement('canvas');
  wrap.appendChild(cv);
  var ctx = cv.getContext('2d', { alpha: true });
  if (!ctx) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var small = window.matchMedia('(max-width: 800px)');
  var W = 0, H = 0, dpr = 1, crosses = [], raf = 0, last = 0, clock = 0, onScreen = true;
  var FRAME = 1000 / 30;
  var SUBTLE = 1;                    // 17 Oct intensity (the 0.85 trial was reverted on 19 Oct)

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function make(anyY) {
    return {
      x: rnd(0, W), y: anyY ? rnd(0, H) : H + 30,
      s: rnd(14, 34),                 // height in px
      vy: -rnd(0.006, 0.016),         // px per ms, slowly upward
      vx: rnd(-0.004, 0.004),
      a: rnd(0.18, 0.34) * SUBTLE,    // peak opacity
      sp: rnd(0.00025, 0.0006),       // fade speed
      ph: rnd(0, 6.283)
    };
  }
  function build() {
    var r = hero.getBoundingClientRect();
    W = Math.max(1, Math.round(r.width)); H = Math.max(1, Math.round(r.height));
    dpr = Math.min(window.devicePixelRatio || 1, small.matches ? 1.5 : 2);
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
    cv.style.width = W + 'px'; cv.style.height = H + 'px';
    // about the same density as the hero had: one cross per ~45,000 px², between 6 and 18
    var n = Math.max(6, Math.min(18, Math.round((W * H) / 45000)));
    n = Math.max(4, Math.round(n * SUBTLE));   // 15% fewer crosses
    if (small.matches) n = Math.max(3, Math.round(n / 2));
    crosses = [];
    for (var i = 0; i < n; i++) crosses.push(make(true));
  }
  function cross(c, alpha) {
    var s = c.s, w = Math.max(2, s * 0.17), arm = s * 0.62, top = c.y - s / 2;
    ctx.globalAlpha = alpha;
    ctx.fillRect(c.x - w / 2, top, w, s);                       // upright
    ctx.fillRect(c.x - arm / 2, top + s * 0.27 - w / 2, arm, w); // cross-beam
  }
  function draw(t) {
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    // one soft warm light drifting behind the crosses
    var gx = (0.72 + 0.12 * Math.sin(t * 0.00009)) * W, gy = (0.35 + 0.15 * Math.cos(t * 0.00007)) * H;
    var g = ctx.createRadialGradient(gx, gy, 0, gx, gy, Math.max(W, H) * 0.55);
    g.addColorStop(0, 'rgba(255, 236, 190, ' + (0.16 * SUBTLE).toFixed(3) + ')');
    g.addColorStop(1, 'rgba(255, 236, 190, 0)');
    ctx.globalAlpha = 1; ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = '#ffffff';
    for (var i = 0; i < crosses.length; i++) {
      var c = crosses[i];
      var k = 0.5 - 0.5 * Math.cos(t * c.sp + c.ph); // 0..1..0: fades in and out
      cross(c, c.a * k);
    }
    ctx.globalAlpha = 1;
  }
  function step(dt) {
    for (var i = 0; i < crosses.length; i++) {
      var c = crosses[i];
      c.y += c.vy * dt; c.x += c.vx * dt;
      if (c.y < -30 || c.x < -30 || c.x > W + 30) crosses[i] = make(false);
    }
  }
  function loop(now) {
    raf = 0;
    if (!onScreen || document.hidden) return;
    if (!last) last = now;
    var dt = now - last;
    if (dt >= FRAME) { last = now; dt = Math.min(dt, 100); clock += dt; step(dt); draw(clock); }
    raf = requestAnimationFrame(loop);
  }
  function start() { if (!raf && !reduce.matches) { last = 0; raf = requestAnimationFrame(loop); } }
  function still() { draw(4000); }
  build();
  if (reduce.matches) still(); else start();
  var ro = window.ResizeObserver ? new ResizeObserver(function () { build(); if (reduce.matches) still(); }) : null;
  if (ro) ro.observe(hero); else window.addEventListener('resize', function () { build(); if (reduce.matches) still(); });
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; if (onScreen) start(); }, { threshold: 0 }).observe(hero);
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) start(); });
  reduce.addEventListener && reduce.addEventListener('change', function () { if (reduce.matches) { if (raf) cancelAnimationFrame(raf); raf = 0; still(); } else start(); });
})();
